import styled, { css } from 'styled-components';
import { LanguagePairBreadcrumbs as LanguagePairBreadcrumbsComponent } from 'src/containers';
import { MemriseTeamBanner as MemriseTeamBannerComponent } from '../MemriseTeamBanner';
import FilmCelluloidImage from './assets/film-celluloid@2x.jpg';

export const Backdrop = styled.div(
  () => css`
    background:
      linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%),
      url('${FilmCelluloidImage}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    margin: unset;
    color: ${theme.co.neutral99};
    ${theme.typography.paragraph.base}

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.l}
    }
  `,
);

export const LanguagePairBreadcrumbs = styled(LanguagePairBreadcrumbsComponent)(
  ({ theme }) => css`
    margin-top: unset;
    padding-top: ${theme.sz.s4};

    @media (min-width: ${theme.sz.md}) {
      max-width: ${theme.sz.lg};
      margin-left: auto;
      margin-right: auto;
      padding-top: ${theme.sz.s14};
      padding-left: ${theme.sz.s6};
      padding-right: ${theme.sz.s6};
    }

    @media (min-width: ${theme.sz.xxl}) {
      max-width: ${theme.sz.xxl};
      padding-left: ${theme.sz.s20};
    }
  `,
);

export const MemriseTeamBanner = styled(MemriseTeamBannerComponent)(
  ({ theme }) => css`
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translateY(50%);

    @media (max-width: calc(${theme.sz.md} - 1px)) {
      padding-left: ${theme.sz.s6};
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    @media (min-width: ${theme.sz.md}) {
      left: ${theme.sz.s6};
    }

    @media (min-width: ${theme.sz.xxl}) {
      left: ${theme.sz.s20};
    }
  `,
);

export const MoviesJumbotron = styled.div(
  ({ theme }) => css`
    padding-bottom: ${theme.sz.s8};
  `,
);

export const PositioningContainer = styled.div(
  ({ theme }) => css`
    padding-left: ${theme.sz.s6};
    padding-right: ${theme.sz.s6};
    padding-bottom: ${theme.sz.s14};
    position: relative;

    @media (min-width: ${theme.sz.md}) {
      width: 100%;
      max-width: ${theme.sz.lg};
      margin-left: auto;
      margin-right: auto;
      padding-bottom: ${theme.sz.s26};
    }

    @media (min-width: ${theme.sz.xxl}) {
      max-width: ${theme.sz.xxl};
      padding-left: ${theme.sz.s20};
    }
  `,
);

export const Title = styled.h1(
  ({ theme }) => css`
    margin: unset;
    color: ${theme.co.neutral99};
    ${theme.typography.heading.mobile.accent.xxl};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.accent.xxl}
    }
  `,
);
